/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { FC, useMemo } from 'react';

interface ComponentRendererProps {
  components?: Queries.PageComponentsComponentsFragment[];
  allComponents?: Record<string, any>;
  dataLayerClickContext?: string;
}

interface DynamicComponentProps {
  alias: string;
  configuration: Record<string, any>;
  count: number;
  allComponents?: Record<string, any>;
  dataLayerClickContext?: string;
}

interface ComponentProps {
  data?: Record<string, any>;
  dataLayerClickContext?: string;
}

const DynamicComponent: FC<DynamicComponentProps> = ({
  alias,
  configuration,
  count,
  allComponents,
  dataLayerClickContext,
}) => {
  // check for fieldGroupName/ alias

  if (!alias) {
    return null;
  }
  // 1. Generate the component name
  const componentName: string = alias.replace('ComponentType', '');

  // 2. Grab the layout
  const TagName: FC<ComponentProps> = allComponents?.[componentName];

  // 3. Check it actually exists
  if (!TagName) {
    // 3.a Not found
    return process.env.NODE_ENV === 'development' ? (
      <>
        <p>
          <b>*** 🔧 COMPONENT not found: {componentName} 🔧 ***</b>
        </p>
        {/* {configuration && <DataPreview data={configuration} />} */}
        <hr />
      </>
    ) : null;
  }

  // 3b. return component
  return (
    <>
    <TagName
      data={{ ...configuration }}
      data-alias={alias}
      data-count={count}
      data-test={`component-${alias}`}
      dataLayerClickContext={dataLayerClickContext}
    />
    </>
  );
};

export const ComponentRenderer = ({
  components,
  allComponents,
  dataLayerClickContext,
}: ComponentRendererProps) => {
  const renderedComponents = useMemo(
    () =>
      components &&
      components.length >= 1 &&
      components.map((item, layoutIndex) => (
        <DynamicComponent
          key={`${item?.remoteTypeName}-${layoutIndex}`}
          alias={item?.remoteTypeName}
          configuration={item}
          count={layoutIndex}
          data-test={`component-${item?.remoteTypeName}-${layoutIndex}}`}
          allComponents={allComponents}
          dataLayerClickContext={dataLayerClickContext}
        />
      )),
    [allComponents, components]
  );

  if (!renderedComponents || renderedComponents.length === 0) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{renderedComponents}</>;
};
